"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.currentlySmokingMessages = exports.CurrentlySmoking = void 0;
const schema_1 = require("../../../../../schema");
var CurrentlySmoking;
(function (CurrentlySmoking) {
    CurrentlySmoking["YES"] = "YES";
    CurrentlySmoking["NO"] = "NO";
})(CurrentlySmoking || (exports.CurrentlySmoking = CurrentlySmoking = {}));
exports.currentlySmokingMessages = {
    [CurrentlySmoking.YES]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.smoking.currentlySmoking.YES",
        defaultMessage: "Igen"
    },
    [CurrentlySmoking.NO]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.smoking.currentlySmoking.NO",
        defaultMessage: "Nem"
    }
};
const currentlySmoking = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CurrentlySmoking.YES),
    schema_1.Schema.singleChoiceItem(CurrentlySmoking.NO)
]);
const cigarettesPerDay = schema_1.Schema.number().integer().min(1).max(500);
const numberOfYears = schema_1.Schema.number().precision(1).min(1).max(100);
const packYears = schema_1.Schema.expression(`toPrecision({../cigarettesPerDay} / 20 * {../numberOfYears} , 1)`);
const cigarettesPackYears = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../currentlySmoking} === "YES"`), schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ cigarettesPerDay, numberOfYears, packYears })
    .interpretation({ vocab: "ktx", code: "smoking_cigarettes_pack_years" }));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ currentlySmoking, cigarettesPackYears })
    .interpretation({ vocab: "ktx", code: "smoking_statement" });
